export var UPDATE_STORE_INFO = "store_info/UPDATE_STORE_INFO";
export function updateStoreInfo(storeInfo) {
    return {
        type: UPDATE_STORE_INFO,
        storeInfo: storeInfo,
    };
}
